module.exports = __webpack_public_path__ + "static/media/wallet-01.da7d5291.svg";